/* AK26 · Kalender-Auswahl — Verhalten zur Section sections/ak-kalender-auswahl.liquid
   - Add-to-Cart pro Zeile per fetch (Menge 1, exakte Varianten-ID), ohne Navigation
   - Zustände idle → loading → success (2 s) → idle, error mit Inline-Text
   - Nach Erfolg: Theme-Cart-Drawer über window.cart.getCart() (Refresh + Öffnen + theme:cart:added)
   - Tracking: view_item_list / select_item / add_to_cart (GA4-Schema) in window.dataLayer
     + Shopify.analytics.publish für den Custom Pixel
   Ohne JS: das Produkt-Formular postet klassisch auf /cart/add (Redirect zum Warenkorb). */
(function () {
  'use strict';

  var SUCCESS_MS = 2000;

  function track(root, eventName, ecommerce) {
    var payload = {
      event: eventName,
      placement: root.dataset.placement || '',
      ecommerce: ecommerce
    };
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(payload);
    } catch (e) { /* Tracking darf die Funktion nie blockieren */ }
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('kalender_auswahl_' + eventName, payload);
      }
    } catch (e) { /* s. o. */ }
  }

  function itemData(root, row) {
    return {
      item_id: row.dataset.productId,
      variant_id: row.dataset.variantId,
      item_name: row.dataset.title,
      price: parseFloat(row.dataset.price) || 0,
      index: parseInt(row.dataset.index, 10) || 0,
      item_list_name: root.dataset.listName || 'kalender_auswahl'
    };
  }

  function setState(btn, state) {
    btn.dataset.state = state;
    btn.disabled = state === 'loading';
    if (state === 'loading') { btn.setAttribute('aria-busy', 'true'); } else { btn.removeAttribute('aria-busy'); }
  }

  function announce(root, text) {
    var live = root.querySelector('[data-ka-live]');
    if (!live) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = text; }, 30);
  }

  function refreshCart(root) {
    var wantsDrawer = root.dataset.openDrawer === 'true';
    if (wantsDrawer && window.cart && typeof window.cart.getCart === 'function') {
      /* Theme-eigener Weg: lädt api-cart-items, aktualisiert Zähler, feuert theme:cart:added, öffnet Drawer */
      window.cart.getCart();
      return;
    }
    /* Fallback / Drawer aus: Zuhörer im Theme (Zähler, Popups) informieren */
    document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true }));
  }

  function addToCart(root, form) {
    var btn = form.querySelector('[data-ka-add]');
    var row = form.closest('[data-ka-row]');
    if (!btn || !row || btn.disabled || btn.dataset.state === 'loading') return;

    var label = btn.querySelector('[data-ka-label]');
    var errEl = row.querySelector('[data-ka-error]');
    var idleLabel = label ? label.textContent : '';
    var variantId = parseInt(row.dataset.variantId, 10);
    var title = row.dataset.title || '';

    btn.style.width = btn.offsetWidth + 'px'; /* Breite bleibt über alle Zustände stabil */
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    setState(btn, 'loading');

    var url = (root.dataset.cartAddUrl || '/cart/add') + '.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) {
        return response.json().then(function (json) { return { ok: response.ok, json: json }; });
      })
      .then(function (result) {
        if (!result.ok || (result.json && result.json.status)) throw result.json || {};
        setState(btn, 'success');
        if (label) label.textContent = root.dataset.labelAdded || idleLabel;
        announce(root, title + ' ' + (root.dataset.labelAdded || ''));
        track(root, 'add_to_cart', {
          currency: root.dataset.currency || '',
          value: parseFloat(row.dataset.price) || 0,
          items: [Object.assign(itemData(root, row), { quantity: 1 })]
        });
        refreshCart(root);
        window.setTimeout(function () {
          setState(btn, 'idle');
          if (label) label.textContent = idleLabel;
          btn.style.width = '';
        }, SUCCESS_MS);
      })
      .catch(function (err) {
        var message = (err && (err.description || err.message)) || root.dataset.labelError || 'Fehler';
        if (typeof message !== 'string') message = root.dataset.labelError || 'Fehler';
        setState(btn, 'error');
        if (label) label.textContent = idleLabel;
        btn.style.width = '';
        if (errEl) { errEl.textContent = message; errEl.hidden = false; }
        announce(root, message);
      });
  }

  function init(root) {
    if (root.dataset.kaInit === 'true') return;
    root.dataset.kaInit = 'true';

    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-ka-row]'));
    if (!rows.length) return;

    /* view_item_list — einmal, sobald die Section sichtbar wird */
    var viewed = false;
    function trackView() {
      if (viewed) return;
      viewed = true;
      track(root, 'view_item_list', {
        item_list_name: root.dataset.listName || 'kalender_auswahl',
        items: rows.map(function (row) { return itemData(root, row); })
      });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); trackView(); }
      }, { threshold: 0.3 });
      io.observe(root);
    } else {
      trackView();
    }

    /* select_item — echter Link, Navigation bleibt dem Browser überlassen */
    root.querySelectorAll('[data-ka-select]').forEach(function (link) {
      link.addEventListener('click', function () {
        var row = link.closest('[data-ka-row]');
        if (row) track(root, 'select_item', {
          item_list_name: root.dataset.listName || 'kalender_auswahl',
          items: [itemData(root, row)]
        });
      });
    });

    /* Add-to-Cart — Formular abfangen, kein Seitenwechsel, keine Zeilen-Navigation */
    root.querySelectorAll('[data-ka-form]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopPropagation();
        addToCart(root, form);
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-kalender-auswahl]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  /* Theme-Editor: Section nach Änderungen neu initialisieren */
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
